var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAll = function SvgIcAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .5a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM3.3 7.4a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Zm2.7 0a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Zm2.7 0a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Z"
  })));
};
export default SvgIcAll;